import React from "react"
import PermissionsManager from "./PermissionsManager"

const PlatformPermissions = () => {
  return <PermissionsManager />
}

export default PlatformPermissions